'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Generates the headers for a request to the insurance API according to the fetch API.
 * @param {String} acceptLanguage - Language for the app.
 * @param {Object} [authorization=null] - Object containing authorization data for the request.
 * @returns {Object} The headers object.
 */
exports.default = function (acceptLanguage) {
  var authorization = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var headers = {
    Accept: 'application/vnd.ingle+json; version=1',
    'Accept-Language': acceptLanguage,
    'Content-Type': 'application/json; charset=utf-8'
  };

  return authorization ? _extends({}, headers, {
    Authorization: authorization.token_type + ' ' + authorization.access_token
  }) : headers;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/requests/makeHeaders.js
// module id = 819
// module chunks = 0